import React from "react"
import styled from "styled-components"
import { useSelector } from "react-redux"
import { StoreType } from "client/store"
import { VERSION } from "const"


export const Layout = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    background: ${(props) => props.theme.layoutBackground};
`
export const Header = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: ${(props) => props.theme.layoutSizes.headerHeight}px;
    background: ${(props) => props.theme.headerBackground};
`
export const MenuColumn = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: ${(props) => props.theme.layoutSizes.menuWidth}px;
    height: 100%;
`
export const MenuColumnHeader = styled.h1`
    width: 100%;
    height: ${(props) => props.theme.layoutSizes.headerHeight}px;
    margin: 0;
    padding: 15px 20px;
    box-sizing: border-box;
    font-size: 24px;
    font-weight: 700;
    font-family: ${(props) => props.theme.openSans};
`
export const MenuContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100% - ${(props) => props.theme.layoutSizes.headerHeight}px);
    overflow-y: scroll;
    background: ${(props) => props.theme.menuBackground};

    &::-webkit-scrollbar {
        width: 0;
    }
`
export const ContentColumn = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: ${(props) => props.theme.layoutSizes.menuWidth}px;
    width: calc(100% - ${(props) => props.theme.layoutSizes.menuWidth}px);
    height: 100%;
    padding-right: ${(props) => props.theme.layoutSizes.sidebarWidth}px;
    overflow-y: scroll;
`
export const ContentColumnHeader = styled.div`
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    justify-content: end;
    position: relative;
    width: 100%;
    height: ${(props) => props.theme.layoutSizes.headerHeight}px;
    z-index: 2;
`
export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
    width: 100%;
`
export const SidebarColumn = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    right: ${(props) => props.theme.scrollbarSize}px;
    width: ${(props) => props.theme.layoutSizes.sidebarWidth}px;
    height: 100%;
`
export const SidebarColumnHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: ${(props) => props.theme.layoutSizes.headerHeight}px;
`
export const SidebarContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: calc(100% - ${(props) => props.theme.layoutSizes.headerHeight}px);
    padding-top: 10px;
    background: ${(props) => props.theme.sidebarBackground};

    & > div {
        margin-bottom: 7px;
    }
`

const FooterWrapper = styled.div<{
    loginPage: boolean
}>`
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    position: relative;
    bottom: ${(props) => (props.loginPage ? "unset" : 0)};
    top: ${(props) => (props.loginPage ? "100%" : "unset")};
    transform: ${(props) => (props.loginPage ? "translateY(-100%)" : "unset")};
    width: 100%;
    height: ${(props) => props.theme.layoutSizes.footerHeight}px;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    color: ${(props) => props.theme.footerColor};
`
export const Footer = () => {
    const { userId, accountId } = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const year = new Date().getFullYear()
    const copyright = lang.copyrightFooter.replace("{year}", year.toString())

    const loginPage = !(userId && accountId && true)

    return (
        <FooterWrapper loginPage={loginPage}>
            {`${copyright} ${VERSION}`}
        </FooterWrapper>
    )
}
